import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';

export class ErrorEmailInvalid extends React.Component {
  render() {
    return (
      this.props.isDisplay ?
        <span className="invalid-feedback">
          <FormattedMessage {...messages.error.email} />
        </span>
        : null
    );
  }
}

ErrorEmailInvalid.propTypes = {
  isDisplay: PropTypes.bool,
};